import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

const STATUS_TO_BACKEND = { closed: 'finished' }
const STATUS_FROM_BACKEND = { finished: 'closed' }

function toBackendStatus(status) {
  return STATUS_TO_BACKEND[status] ?? status
}

function fromBackendStatus(status) {
  return STATUS_FROM_BACKEND[status] ?? status
}

function mapSurvey(raw) {
  return {
    id: raw._id,
    name: raw.name,
    startDate: raw.startDate ?? null,
    endDate: raw.endDate ?? null,
    status: fromBackendStatus(raw.status),
    totalRespondents: raw.totalRespondents ?? 0,
    createdAt: raw.createdAt,
    registrationCode: raw.registrationCode ?? null,
    offlineCapable: raw.offlineCapable ?? null,
  }
}

export async function listSurveys({ status = null, search = '', page = 0, size = 6 } = {}) {
  const parameters = {
    page: page + 1,
    limit: size,
  }

  if (Array.isArray(status) && status.length)
    parameters.status = status.map(toBackendStatus)
  else if (status)
    parameters.status = toBackendStatus(status)

  if (search?.trim())
    parameters.search = search.trim()

  const response = await apiClient('generic-survey').get(SURVEY_ENDPOINTS.LIST, { params: parameters })
  const { data, pagination } = response.data

  return {
    items: data.map(mapSurvey),
    total: pagination.totalItems,
    page,
    size,
  }
}
